import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import git1 from "../../assets/Images/gitpic/1.png";
import git2 from "../../assets/Images/gitpic/2.png";
import git3 from "../../assets/Images/gitpic/3.png";
import git4 from "../../assets/Images/gitpic/4.png";
import git5 from "../../assets/Images/gitpic/5.png";
import git6 from "../../assets/Images/gitpic/6.png";
import git7 from "../../assets/Images/gitpic/7.png";
import git8 from "../../assets/Images/gitpic/8.png";




import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



// import figma from "../../assets/Images/figma.png";

// import lowprot1 from "../../assets/Images/lowfidprot.JPG";
// import lowprot2 from "../../assets/Images/lowfidprot1.JPG";


import Slideshow from "../../assets/Slideshow/Slideshow"; 


const Lo2Git = () => {
    const navigate = useNavigate();

    const images = [git1, git2, git3,git4,git5,git6,git7,git8];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo2-headings">
                <h1>Git Repository, Readme file, and Commit & Branches</h1>
                <p>I need to show how I can use git professionally</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>

            <div className="content-lo2">
                <div className="content-lo2-git">
                    <div className="content-lo2-git-text">
                        <h1>Arduino for marketing campaign</h1>
                        <p>
                            For our interactive 3D poster project, which use Arduino to play a cat sound when someone
                            walks by, I used GitHub as to work as a tool. This allowed me to efficiently collaborate
                            with my teammate Adib by sharing the Arduino code through a centralized repository. Using Git
                            not only helped us stay organized but also ensured that we had a secure and trackable development workflow.
                        </p>
                        <h2>Readme file</h2>
                        <p>
                            One of the essential parts of a professional repository is a well-written README file. I customized
                            the README to give a clear overview of the project, including:
                            <ul>
                                <li>Short description of the project</li>
                                <li>Setup instructions</li>
                                <li>Dependencies</li>
                            </ul>
                        </p>
                        <h2>Commits & Branches</h2>
                        <p>
                            To avoid conflicts and keep our main branch clean, I created my own branch where I could safely develop.
                            I committed few of the progress to document what changes were made and why.
                        </p>
                            
                        <p>
                            From experience in previous semesters, I have learned that working in separate branches and only merging
                            into the main branch when our project is finalized is the best practice. It helps prevent overwriting,
                            broken code, or merge conflicts when working with others.
                        </p>

                        <p>
                            By the end of our development, once we were confident everything worked as intended, we merged the feature
                            branch into the main branch. This makes sures that the main branch always contained the most stable version of our code.
                        </p>
                        <p>
                            Here is the link to our git <a href="https://git.fhict.nl/I516415/arduino-cat-sound">Click here</a>
                        </p>
                        
                    </div>

                    <div className="content-lo2-git-text2">
                        <h1>Re-learning to use git again</h1>
                        <p>
                            During this semester I also tried to review what I previously did to work on git, commiting, pushing, and making read-me file. I had some help in setting
                            the git for this portfolio from my groupmate, Tommy helped me remember how to commit, fetch, and push using git bash. 
                        </p>
                        <h2>Feedback on how I should use git</h2>
                        <p>
                            I received feedback on how to properly use Git branches. Previously, I named branches after myself or my group, but I learned that the correct approach
                            is to name each branch based on the specific task or feature being worked on. After receiving this feedback, I started naming branches according to the
                            task and keeping them separate for each piece of work, which helped improve the structure and clarity of my version control.
                        </p>
                        
                    </div>

                    <div className="content-lo2-git-text3">
                        <h1>Shared Google Drive</h1>
                        <p>
                            In addition to using GitHub for code, my group also relied on a shared Google Drive to manage all non-code assets for the project. This included:
                            <ul>
                                <li>Poster design drafts and 3D modeling files.</li>
                                <li>Meeting notes, task distribution, and planning documents.</li>
                                <li>Presentation materials and export-ready assets.</li>
                                <li>Research results, photos from testing, and QR code designs.</li>
                            </ul>
                            Using Google Drive helped working together since it provided a single destination for all of our files. Everyone in the group had access and editing
                            rights, which helped us keep the project structured and ensured that the most recent version of each file was always available. It also made it simple to submit assets and share them with the teachers and clients as needed.
                            with the link i provided you can check out our group drive folder <a href="https://drive.google.com/drive/folders/1qQPXErz-MN3d4KuoYhiL_qbb-9R-b9s9?usp=drive_link">Click here</a>
                        </p>
                        <h2>Feedback and Reflection on Why Google Drive Wasn't Ideal for Collaboration </h2>
                        <p>
                            While Google Drive was helpful for quick sharing and central access, I received valuable feedback pointing out that it wasn't the most suitable tool for collaborative work in a professional setting.
                        </p>
                        <p>
                            One of the feedback during the 3rd assesment from my teacher made me reflect on the limitations that could happen
                            <ul>
                                <li>I couldn't track detailed version history or restore past iteration.</li>
                                <li>Multiple people editing the same file risked overwriting each other's work with no warning or merge control.</li>
                            </ul>
                            This feedback and experienced taught me to think more crtitically about the tools I choose, not only should they be familiar or easy to use, but they also need to encourage effective teamwork, version control, and long-term reliability.
                        </p>
                    </div>

                    <div className="content-lo2-git-slideshow">
                        <Slideshow images={images} />

                    </div>

                    <div className="content-lo2-git-text4">
                        <h1>My Personal Git for Portfolio</h1>
                        <p>
                           After the Feedback I received, I started using Git more seriously to manage my personal portfolio website. I created a dedicated GitHub repository where I documented each stage of my development process using feature-based branches and meaningful commit messages.
                            I received feedback that my use of Git was too minimal there weren't enough commits, and I was naming branches after myself instead of the tasks. To improve, I began:
                            <ul>
                                <li>Naming the braches based on the task I work on</li>
                                <li>Making regular commits to track my progress</li>
                            </ul>
                            This helped me stay organized and made my work more transparent. Even though I'm still learning, I now feel more confident using Git as a proper version control system. Here is the link to my Git <a href="https://git.fhict.nl/I516415/semester3">Click here</a>
                        </p>
                        
                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo2Git;